
const { makeStyles, createStyles } = require("@material-ui/styles");

const useStyles = makeStyles((theme) => createStyles({
    pink: {
        color: "#ffc0cb"
    },
    formControl: {
        width: "100%",
        margin: '7px 0px',
        flex: 1
    },
    ml1: {
        marginLeft: 3
    },
    bold: {
        fontWeight: 'bold'
    },
    box: {
        marginBottom: 40,
        height: 65
    },
    paper2: {
        paddingBottom: theme.spacing(3),
        textAlign: 'left',
        color: theme.palette.text.secondary,
    },
    paper3: {
        padding: theme.spacing(3),
        textAlign: "center",
        backgroundColor: '#fff59d'
    },
    root: {
        width: '100%',
        flexGrow: 1,
        backgroundColor: theme.palette.background.paper,
    },
    grid: {
        width: 1200,
        marginTop: 40,
        [theme.breakpoints.down("sm")]: {
            width: "calc(100% - 20px)"
        }
    },
    avatar: {
        margin: 10,
        backgroundColor: theme.palette.grey['200'],
        color: theme.palette.text.primary,
    },
    avatarContainer: {
        [theme.breakpoints.down('sm')]: {
            marginLeft: 0,
            marginBottom: theme.spacing(4)
        }
    },
    paper: {
        padding: theme.spacing(3),
        textAlign: 'left',
        color: theme.palette.text.secondary,
        margin: '10px'
    },
    itemContainer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        [theme.breakpoints.down('sm')]: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center'
        }
    },
    baseline: {
        alignSelf: 'baseline',
        marginLeft: theme.spacing(4),
        [theme.breakpoints.down('sm')]: {
            display: 'flex',
            flexDirection: 'column',
            textAlign: 'center',
            alignItems: 'center',
            width: '100%',
            marginTop: theme.spacing(2),
            marginBottom: theme.spacing(2),
            marginLeft: 0
        }
    },
    inline: {
        display: 'inline-block',
        marginLeft: theme.spacing(4),
        [theme.breakpoints.down('sm')]: {
            marginLeft: 0
        }
    },
    inlineRight: {
        width: '30%',
        textAlign: 'right',
        marginLeft: 50,
        alignSelf: 'flex-end',
        [theme.breakpoints.down('sm')]: {
            width: '100%',
            margin: 0,
            textAlign: 'center'
        }
    },
    backButton: {
        marginRight: theme.spacing(2)
    },
}))

export default useStyles